import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { DialogRef } from "../dialog/dialog-ref";
import { DIALOG_DATA } from "../dialog/dialog-tokens";

@Component({
    selector: "app-md-confirmation-message-v5",
    templateUrl: "./md-confirmation-message-v5.component.html",
    styleUrls: ["./md-confirmation-message-v5.component.scss"],
    standalone: false
})
export class MdConfirmationMessageV5Component implements OnInit {
  @Input() public opened = false;
  @Input() public data: any;
  @Input() public message: any;

  @Output() closeDialogEvent = new EventEmitter<any>();

  public titlebarTitle = "Confirmation";
  public titlebarCssClass = "modal-title-red";
  public dlgWidth: number = 600;
  public dlgMaxHeight: string = "80%";

  constructor(
    private dialogRef: DialogRef,
    @Inject(DIALOG_DATA) public inputData: v5DlgInputArgs
  ) {}

  ngOnInit(): void {
    if (this.inputData) {
      this.opened = this.inputData.opened;
      this.data = this.inputData.data;
      this.message = this.inputData.message;
    }
  }
  public close(status: any) {
    this.opened = false;

    let savParamters: dlgModelArgs = {
      status: status,
      data: this.data,
    };
    this.closeDialogEvent.emit(savParamters);
    this.dialogRef?.close(savParamters);
  }
}
export interface v5DlgInputArgs {
  opened: boolean;
  dialogWidth: number;
  data: any;
  message: any;
}
export interface dlgModelArgs {
  status: string;
  data: any; //ProposalEntity[]
}
